import React, { useCallback } from "react";
import { FixedSizeList, ListChildComponentProps } from "react-window";
import { UserPictureCache } from "Hooks";
import { isNumber } from "Utils/isNumber";
import UserInfo from "./UserInfo";
import { User } from "./User";
import classes from "./UserInput.module.scss";

interface UserMenuListProps
   extends Omit<React.HTMLAttributes<HTMLDivElement>, "onClick"> {
   userPictureCache: UserPictureCache;
   left?: number;
   top?: number;
   width?: number;
   className?: string;
   users?: User[];
   onClick?: (user: User) => void;
}

const UserMenuList: React.FC<UserMenuListProps> = ({
   userPictureCache,
   users = [],
   onClick,
   className,
   ...props
}) => {
   const itemSize = 52;
   const maxHeight = 160;
   const padding = 8;
   const itemCount = users.length;
   const height = Math.min(maxHeight, itemSize * itemCount + padding * 2);

   const Row = useCallback<React.FC<ListChildComponentProps<User[]>>>(({ data, index, style }) => {
      const user = data[index];

      return <UserInfo
         key={`${user.fullName}-${index}`}
         userPictureCache={userPictureCache}
         style={{
            ...style,
            top: isNumber(style.top)
               ? style.top + padding
               : `calc(${style.top} + ${padding}px)`
         }}
         onClick={() => onClick?.(user)}
         user={user}
         className={classes.listItem}
         {...props}
      />
   }, [onClick, props, padding]);

   return !users.length
      ? <div className={className} {...props}>   No matches found</div>
      : <FixedSizeList
         className={className}
         style={{ padding }}
         itemCount={itemCount}
         itemData={users}
         height={height}
         itemSize={itemSize}
         width="100%"
      >
         {Row}
      </FixedSizeList>
};

export default UserMenuList;
